import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { apiUpdateUser } from '../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { UserAr } from './userAr';
import { updateIn, assoc } from '../../language/module';
import { updateUser } from './module';
import {UserState} from '../../auth/userState';


export const KEY_ACTION = ACTION_TYPE.UPDATE_USER_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.UPDATE_USER_REQUEST,
  ACTION_TYPE.UPDATE_USER_RESPONSE,
  ACTION_TYPE.UPDATE_USER_ERROR,
];

const mapToUpdateUser = (user: UserAr | UserState) => ({
  email:           user.email,
  firstName:       user.firstName,
  lastName:        user.lastName,
  role:            user.role,
  resortLocations: user.resortLocations,
  resetPassword:   user.resetPassword,
  hasEmail:        user.hasEmail,
  });





/**
 * Creates an action to dispatch that updates an existing user
 * @param user the user details being updated
 */
export const updateUserAction = (user: UserAr | UserState) => makeApiAction(
  {
    method:   'PUT',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: (state: IAppState) => apiUpdateUser(state.userState.userId, state.selectedResort.resortId, user.userId),
    body:     JSON.stringify(mapToUpdateUser(user)),
    types:    ACTIONS.map(action => ({ type: action, meta: { user } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION)
                                    || !!getLoading(state, user.userName, KEY_ACTION),
  },
);


const reducer: ApiReducer<any> = (state, action, error, isLoading, payload) => {
  const newUser = action.meta.user as UserAr;

  if (isLoading) {
    return addLoading(state, newUser.userName, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, newUser.userName, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, newUser.userName, KEY_ACTION);

  const updatedUserInUserState = state.userState.userId === newUser.userId ? assoc(
    'userState',
    {...state.userState, resetPassword: newUser.resetPassword, resortLocations: newUser.resortLocations},
    noLoadingOrError,
  ) : noLoadingOrError;

  return assoc(
    'users',
    updateIn(
      user => updateUser(user, newUser),
      user => user.userName === newUser.userName,
      updatedUserInUserState.users || [],
    ),
    updatedUserInUserState,
  );
};


export const updateUserReducer = makeApiReducer<any>(ACTIONS, KEY_ACTION, reducer);
